import appDistrict from "../../views/appSettings/district.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("district", {
    url: "district/:id",
    parent: "app",
    views: {
      view: {
        template: appDistrict,
      },
    },
    reloadOnSearch: false,
    data: { title: "District" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/district/district.urls.js